import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';

import OrdersPaginator from './OrdersPaginator';
import ItemUsageLogs from "js/stores/types/ItemUsageLogs";

export default types
  .model('Item', {
    isLoading: false,
    error: types.maybeNull(types.string),

    alias: types.string,
    title: types.maybe(types.string),
    seller_name: types.maybeNull(types.string),
    seller_email: types.maybeNull(types.string),
    image: types.maybe(types.string),
    item_address: types.maybe(types.string),
    created_at: types.maybe(types.string),
    price: types.maybe(types.number),
    size: types.maybe(types.string),
    item_usage_logs: types.optional(types.array(ItemUsageLogs), []),

    orders: types.optional(OrdersPaginator, {}),
  })
  .actions(self => ({
    afterCreate() {
      self.orders.alias = self.alias;
      self.orders.load();
    },
    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-item-data', self);
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
  }));
